import { extractJsonObject } from "../outline/outlinePrompt.js";
import { SURF_MAX_BULLETS_PER_SLIDE } from "./designerHeuristics.js";
import { layoutCatalogForPrompt } from "./templates.js";
import { validateDesignerOutput } from "./validateLayout.js";
export const SURF_DESIGNER_SYSTEM = [
    "You are a presentation slide Designer agent for Surf.",
    "Choose ONE layout id from the catalog and fill each slot with concise copy in Italian.",
    "Use only slot roles defined for that layout.",
    "Vary layouts across the deck — do NOT default every slide to title-body.",
    "One idea per slide: short title, tight body/bullets, generous whitespace.",
    `Max ${SURF_MAX_BULLETS_PER_SLIDE} bullet lines when using bullets layout (newline-separated).`,
    "Role hints: cover→cover; section→section; quote→quote; data/stat→big-number; comparison→comparison; lists→bullets; dual topics→two-column; image slide→image-left; closing→closing.",
    "Respond ONLY with JSON:",
    '{"layoutId":"bullets","layers":[{"slotRole":"title","content":"..."},{"slotRole":"bullets","content":"line1\\nline2"}]}',
    "",
    "Layout catalog:",
].join("\n");
export function surfDesignerUserPrompt(opts) {
    return [
        `Slide ${opts.slideIndex + 1} of ${opts.slideCount}`,
        opts.presentationType ? `Presentation type: ${opts.presentationType}` : "",
        opts.outlineRole ? `Outline role: ${opts.outlineRole}` : "",
        opts.layoutHint ? `Layout hint from outline: ${opts.layoutHint}` : "",
        ...(opts.roleGuidance ?? []),
        `Headline hint: ${opts.headline}`,
        `Body hint: ${opts.body}`,
        "",
        "Pick the best layout for this role/content and write slot copy. Bullets: newline-separated lines.",
    ]
        .filter(Boolean)
        .join("\n");
}
export function designerSystemWithCatalog() {
    return `${SURF_DESIGNER_SYSTEM}\n${layoutCatalogForPrompt()}`;
}
export function parseDesignerResponse(raw) {
    const obj = extractJsonObject(raw);
    if (!obj)
        throw new Error("Risposta designer non JSON.");
    const layoutId = String(obj.layoutId ?? "").trim();
    const layersRaw = obj.layers;
    if (!layoutId || !Array.isArray(layersRaw)) {
        throw new Error("JSON designer incompleto (layoutId, layers).");
    }
    const layers = layersRaw.map((item) => {
        const o = item;
        return {
            slotRole: String(o.slotRole ?? o.role ?? "").trim(),
            content: String(o.content ?? o.text ?? "").trim(),
            type: o.type,
        };
    });
    const output = { layoutId, layers };
    const err = validateDesignerOutput(output);
    if (err)
        throw new Error(err);
    return output;
}
export function designerOutputToContents(output) {
    const map = {};
    for (const layer of output.layers) {
        map[layer.slotRole] = layer.content;
    }
    return map;
}
